import BackpackIcon from './component.jsx'
export default BackpackIcon
